import { render, staticRenderFns } from "./add-contract.vue?vue&type=template&id=76743b16&scoped=true"
import script from "./add-contract.vue?vue&type=script&lang=js"
export * from "./add-contract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76743b16",
  null
  
)

export default component.exports